import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../lib/auth/AuthProvider.js';
import { landingFor } from './login.js';

/**
 * What the root of this deployment is.
 *
 * Two consoles live in one build — the dispatcher's at `/admin` and the
 * driver's at `/partner` — so `/` cannot be a fixed destination. It was one:
 * `vercel.json` redirected every visitor to `/admin`, which sent every DRIVER
 * to a console their capability forbids, and they met a guard instead of their
 * own work.
 *
 * Deciding it here rather than in `vercel.json` also lets the same build serve
 * `admin.teraago.com` and a driver-facing host from one project: the
 * person decides where they land, not the hostname.
 *
 * A visitor with no session goes to sign in. Nothing is rendered in passing —
 * a flash of the wrong console is how somebody learns a screen exists that they
 * cannot open.
 */
export function TeraAgoEntry(): ReactElement {
  const { account, loading } = useAuth();

  // The session is still being restored from storage. Redirecting now would
  // send a signed-in driver to the login page and straight back again.
  if (loading) return <></>;

  if (account === null) return <Navigate to="/login" replace />;
  return <Navigate to={landingFor(account.capabilities, undefined)} replace />;
}
